import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AuthService } from './core/services/auth.service'
import { DemoService } from './core/services/demo.service'
import { ThemeService } from './shared/services/theme.service'
import { MaintenanceNoticeService } from './core/services/maintenance-notice.service'
import { MapService } from './core/services/map.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '[class.-dark-mode]': 'theme() === "dark"',
    '[class.-light-mode]': 'theme() === "light"',
  },
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Speed Limit Information Maps'
  maintenanceNotice = signal('')
  theme = signal('light')
  private readonly destroyRef = inject(DestroyRef)

  constructor(
    private authService: AuthService,
    private demoService: DemoService,
    private themeService: ThemeService,
    private maintenanceNoticeService: MaintenanceNoticeService,
    private mapService: MapService,
  ) {
    authService.InitializeMsal()
    window.token = async () => this.authService.getAccessToken()
  }

  ngOnInit(): void {
    this.maintenanceNoticeService.notice$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notice) => {
        this.maintenanceNotice.set(notice)
        this.resizeMapAfterLayoutChange()
      })

    this.themeService
      .getTheme$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((theme) => {
        this.theme.set(theme)
      })
  }

  dismissMaintenanceNotice(): void {
    this.maintenanceNotice.set('')
    this.resizeMapAfterLayoutChange()
  }

  private resizeMapAfterLayoutChange(): void {
    requestAnimationFrame(() => this.mapService.map?.resize())
  }
}
